import Container from "@/components/layout/Container";

export default function CalculatorHeader() {

  return (

    <div className="border-b border-border-soft bg-bg-light">

      <Container>

        <div className="
          flex flex-col gap-2
          py-5 md:py-6
        ">

          {/* 🔥 BREADCRUMB */}
          <div className="flex items-center gap-2 text-[12px] text-text-muted">

            <a href="/" className="hover:text-text-primary transition">
              Home
            </a>

            <span>/</span>

            <span className="text-text-primary font-medium">
              Airbnb Calculator
            </span>

          </div>

          {/* 🔥 TITLE */}
          <h1 className="
            text-[20px] md:text-[26px]
            font-semibold
            text-text-primary
            leading-snug
            max-w-[28ch]
          ">
            Estimate your property’s rental potential  
            based on real market data
          </h1>
        </div>

      </Container>

    </div>
  );
}